import { useEffect, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  GET_PLACE_NEW_COURSE_ORDER_CLIENT_PAYS_PRODUCTS,
  GetPlaceNewCourseOrderClientPaysProductsResponse
} from 'share/queries/courses'
import { useSelector } from 'react-redux'
import {
  setCasePlaceOrderUpdateFields,
  isDebtorType1
} from 'reducers/activecase/activecaseSlice'
import {
  HasPlacedCourseOrderStatusType,
  CourseOrderStep,
  getCasePlaceOrderUpdateFields
} from 'share/domain/case'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import {
  CourseTabTitle,
  CoursePaymentType,
  CourseInviteProvider,
  CourseType
} from 'share/domain/course'
import CourseTabPlaceOrderChooseCourseForm from 'components/organisms/CourseTabPlaceOrderChooseCourseForm'
import useLoadingDelay from 'hooks/useLoadingDelay'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'

const CourseTabPlaceOrderChooseCourse = (): JSX.Element => {
  const isDebtor1 = useSelector(isDebtorType1)
  const dispatch = useAppDispatch()
  const activeCase = useAppSelector((state) => state.activeCase)
  const activeCourse = useAppSelector((state) => state.activeCourse)
  const [clientPayProducts, setClientPayProducts] = useState<
    CourseInviteProvider[]
  >([])

  const [getClientPayProducts, { loading, data, error }] =
    useLazyQuery<GetPlaceNewCourseOrderClientPaysProductsResponse>(
      GET_PLACE_NEW_COURSE_ORDER_CLIENT_PAYS_PRODUCTS,
      {
        fetchPolicy: 'network-only'
      }
    )

  const loadingDelay = useLoadingDelay(loading)

  useEffect(() => {
    if (activeCase && activeCase.matter && activeCase.matter.id) {
      getClientPayProducts({
        variables: {
          request: {
            caseId: activeCase.matter.id,
            courseType:
              activeCourse?.activeTab === 'first'
                ? CourseType.CreditCounseling
                : CourseType.DebtorEducation,
            isDebtor1: isDebtor1
          }
        }
      })
    }
  }, [activeCase])

  useEffect(() => {
    if (data) {
      setClientPayProducts(
        data.orders.placeNewCourseOrderClientPayProducts.courseProviders
      )
      dispatch(
        setCasePlaceOrderUpdateFields(
          data.orders.placeNewCourseOrderClientPayProducts
        )
      )
    }
  }, [data])

  useEffect(() => {
    if (error) {
      const errorCasePlaceOrderUpdateFields = getCasePlaceOrderUpdateFields(
        isDebtor1,
        activeCourse?.activeTab === 'first',
        HasPlacedCourseOrderStatusType.ErrorOnChooseCourseStep,
        CourseOrderStep.CourseOrderFailed
      )

      dispatch(setCasePlaceOrderUpdateFields(errorCasePlaceOrderUpdateFields))
    }
  }, [error])

  useEffect(() => {
    let title = ''
    if (activeCourse?.activeTab) {
      title =
        activeCourse.activeTab === 'first'
          ? CourseTabTitle.TAKE_FIRST_COURSE
          : CourseTabTitle.TAKE_SECOND_COURSE
    }

    dispatch(setTitle(title))
  }, [activeCourse?.activeTab])

  return (
    <div>
      {loadingDelay && loadingSpinnerPortal()}
      <CourseTabPlaceOrderChooseCourseForm
        coursePaymentType={CoursePaymentType.ClientPays}
        courseProviderList={clientPayProducts}
      />
    </div>
  )
}

export default CourseTabPlaceOrderChooseCourse
